import PlaylistRow from "@Components/game/playlists/common/playlist-row";
import NavSection from "@Components/game/sections/nav-section";
import { usePlaylistsContext } from "@Context/game/playlists/playlists-context";
import { faPlayCircle } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { useTheme } from "@mui/material";
import "swiper/css";

interface IContinueSection {}

const ContinueSection = ({}: IContinueSection) => {
  const theme = useTheme();
  const { playlists, loading } = usePlaylistsContext();
  const { i18n } = useI18n();

  return (
    <NavSection title={i18n("playlists.subheader.featured")} icon={faPlayCircle} headerSx={{ padding: theme.spacing(0, 6) }}>
      <PlaylistRow size="medium" playlists={playlists || []} loading={loading} />
    </NavSection>
  );
};

export default ContinueSection;
